import React, { Fragment } from 'react'
import { SubstatusAliasCheckbox } from './substatus-alias-checkbox'
import { I18nConsumer } from '../i18n-provider'
import { css } from '@emotion/css'
import { vulnerabilityBehaviorTitle } from './approval-workflow-settings-form'
import { TextInput } from '../../legacy-design-system/form-text'
import { aliasCharsAllowed } from './vulnerability-behavior-panel'

export interface SubstatusAliasSettingsFormProps {
  readonly enabled: boolean
  readonly alias: string
  readonly savedAlias?: string
  readonly onEnabling: (enabled: boolean) => void
  readonly onAliasChange: (alias: string) => void
}

export const textBoxTestId = 'aliasTexboxTestId'

export function SubstatusAliasSettingsForm({
  enabled,
  alias,
  savedAlias,
  onEnabling,
  onAliasChange
}: SubstatusAliasSettingsFormProps) {
  return (
    <I18nConsumer>
      {({ intl }) => (
        <div
          className={css`
            margin-top: 40px;
          `}
        >
          <strong className={vulnerabilityBehaviorTitle}>
            {intl.formatMessage({
              id: 'title_notAProblemStatusOptions'
            })}
          </strong>
          <div
            className={css`
              color: #bfbfbf;
              margin-top: -10px;
            `}
          >
            <div
              className={css`
                margin-bottom: 16px;
              `}
            >
              {intl.formatMessage({
                id: 'detail_enableSubstatusAliasSettings'
              })}
            </div>
            <SubstatusAliasCheckbox
              label={intl.formatMessage({
                id: 'detail_enableSubstatusAliasSettings_checkbox'
              })}
              value={enabled}
              onChange={onEnabling}
              savedAlias={savedAlias}
            />
            {enabled && (
              <Fragment>
                <div
                  className={css`
                    width: 300px;
                  `}
                >
                  <div
                    className={css`
                      display: flex;
                      padding: 0 0 4px 0px;
                      justify-content: flex-end;
                    `}
                  >
                    <span
                      className={css`
                        flex-basis: 275px;
                      `}
                    >
                      <TextInput
                        onChange={onAliasChange}
                        value={alias}
                        data-testid={textBoxTestId}
                      />
                    </span>
                  </div>
                  <div
                    className={css`
                      text-align: right;
                    `}
                  >
                    {intl.formatMessage(
                      { id: 'detail_charactersLeft' },
                      { count: aliasCharsAllowed - alias.length }
                    )}
                  </div>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      )}
    </I18nConsumer>
  )
}
